import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Investor from './Home/investor';

function App() {
  return (
    <div className='bg-[#0E0E0E] h-screen'>
      <Router>
        <Routes>         
          <Route path='/' element={<Navigate to='/coming-soon' replace />} />          
          <Route path='/coming-soon' element={<Home />} />    
          <Route path='/investor' element={<Investor />} />        
          <Route path='*' element={<Navigate to='/coming-soon' replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
